import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'
import { FunctionComponent } from 'react'
import config from '@config'
import EmbeddedContent from '@components/EmbeddedContent'
import useDisableThirdPartyScripts from '@hooks/useDisableThirdPartyScripts'

const {
  infogram: { staticPageUrl },
} = config

interface InfogramProps {
  name: string
  id: string
  isPlusContent?: boolean
}

const Infogram: FunctionComponent<InfogramProps> = ({ id: infogramId }) => {
  const disableThirdPartyScripts = useDisableThirdPartyScripts()

  if (disableThirdPartyScripts) {
    return null
  }

  return <EmbeddedContent url={`${staticPageUrl}${infogramId}`} />
}

const widget = {
  kind: ['widget', 'tool', 'infogram'],
  component: Infogram,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
